import styled from 'styled-components';

export const GridOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const DivHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonLink = styled.button`
  display: flex;
  margin-right: 20px;
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: unset;
  cursor: pointer;
`;
